import {
  Component,
  ElementRef,
  EventEmitter,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { EventsService } from "../../../_services/eventsServices/events.service";
import { RowEventEmit } from "../event-page-models/row-event-emit";
import { ParentEventMessageType } from "../event-page-models/parent-event-message";
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";
import { EventEditor } from "../event-page-models/event-editor";
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { BudgetSection } from "../event-page-models/budget-section";
import { FormGroupDirective } from "@angular/forms";
import { TranslationService } from "../../../_services/translation.service";
import { Observable } from "rxjs/Observable";
import { ITranslations } from "../../../_models/ITranslations";

@Component({
  selector: "parent-event-form-budget-section",
  templateUrl: "create-parent-event-form-budget-section.component.html",
  styleUrls: ["./create-parent-event-form-budget-section.component.scss"],
  animations: [
    trigger("openClose", [
      state(
        "open",
        style({
          height: "200px",
          maxHeight: "4000px",
          opacity: 1,
        })
      ),
      state(
        "closed",
        style({
          height: "1px",
          opacity: 0,
        })
      ),
      transition("open => closed", [animate("0.2s")]),
      transition("* => open", [animate("0.2s")]),
      transition("closed => open", [animate("0.2s")]),
    ]),
  ],
})
export class CreateParentEventFormBudgetSection implements OnInit {
  @ViewChild("multiselectInput") public multiselectInput: ElementRef;
  @ViewChild("componentMain") public componentMain: ElementRef;
  @Output("menu-event") public rowEvent: EventEmitter<RowEventEmit> =
    new EventEmitter<RowEventEmit>();
  public readonly $permittedEventEditors: BehaviorSubject<EventEditor[]> =
    new BehaviorSubject<EventEditor[]>([]);
  public readonly $eventEditorsSearchResults: BehaviorSubject<EventEditor[]> =
    new BehaviorSubject<EventEditor[]>([]);
  public budgetSection: BudgetSection | null = null;
  public translations$: Observable<ITranslations>;
  public displayAllBudgetSections: boolean = false;

  constructor(
    private translationService: TranslationService,
    private eventsService: EventsService,
    private formInput: FormGroupDirective
  ) {
    this.translations$ = this.translationService.translations;
  }
  public ngOnInit() {
    if (this.formInput && this.formInput.form) {
      const value = this.formInput.form.value;
      this.budgetSection = value as BudgetSection;
    }
  }

  public updateBudgetSelection($event: BudgetSection | null) {
    this.budgetSection = $event;

    this.formInput.form.patchValue({
      budgetSectionId: ($event && $event.budgetSectionId) || null,
      budgetSectionDescription:
        ($event && $event.budgetSectionDescription) || null,
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/events-screen/create-parent-event-form-budget-section/create-parent-event-form-budget-section.component.ts